import { ArgumentAxis, Chart, LineSeries, ValueAxis } from "@devexpress/dx-react-chart-material-ui";
import { Box, Paper, Typography } from "@material-ui/core";
import { format, parse } from "date-fns";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Center } from "../../../../components/center";
import { ErrorPanel } from "../../../../components/error_panel";
import { Loading } from "../../../../components/loading";
import { IAsyncData } from "../../../../core/models";
import { isError, isPending, isSuccess } from "../../../../core/redux";
import { IAppReduxState } from "../../../../redux/store";
import { IBudgetHistory } from "../../data/entities";
import { budgetHistoryRedux } from "../state/state";

interface IProps {}

const tickFormat = () => (date: any) => {
  return format(parse(date, "dd MMMM yyyy HH:mm", new Date()), "dd MMM");
};

export const BudgetHistoryGraph: React.FC<IProps> = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(budgetHistoryRedux.actions.getList());
  }, [dispatch]);
  const budgetHistoryListBranch = useSelector<IAppReduxState, IAsyncData<IBudgetHistory[]>>(
    (state) => state.budgetHistory.list,
  );

  return (
    <Box mt={3}>
      <Loading loading={isPending(budgetHistoryListBranch)}>
        <Paper>
          {budgetHistoryListBranch.data && (
            <Chart
              data={budgetHistoryListBranch.data
                .map((h) => ({
                  ...h,
                  createdDate: format(h.createdDate, "dd MMMM yyyy HH:mm"),
                }))
                .reverse()}
            >
              <ArgumentAxis showGrid showTicks tickFormat={tickFormat} />
              <ValueAxis />
              <LineSeries valueField="amountAfter" argumentField="createdDate" />
            </Chart>
          )}

          {isError(budgetHistoryListBranch) && (
            <Center>
              <Box py={3}>
                <ErrorPanel branch={budgetHistoryListBranch} />
              </Box>
            </Center>
          )}

          {isSuccess(budgetHistoryListBranch) && budgetHistoryListBranch.data?.length === 0 && (
            <Center>
              <Box py={3}>
                <Typography>Məlumat yoxdur</Typography>
              </Box>
            </Center>
          )}
        </Paper>
      </Loading>
    </Box>
  );
};
